class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelector(".continue-shopping-link").addEventListener("click", this.close.bind(this));
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close(evt) {
    if (evt) evt.preventDefault();
    this.notification.classList.remove("active");

    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (parsedState) {
      this.productId = parsedState.id;
      // running locally this \/ is null and what is causing the JS error
      if (parsedState.sections != null) {
        this.getSectionsToRender().forEach((section) => {
          document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        });
      }
    }

    if (this.header) this.header.reveal();

    if (parsedState || document.getElementById("cart-notification-products").innerHTML.length < 1) {
      this.renderCartContent();
    }
    this.open();
  }

  getSectionsToRender() {
    return [
      // {
      //   id: "cart-notification-product",
      //   selector: `#cart-notification-product-${this.productId}`,
      // },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  renderCartContent() {
    this.enableLoading();
    const cartItemList = document.getElementById("cart-notification-products");
    cartItemList.innerHTML = "";
    fetch(`${routes.cart_url}`, {
      method: "GET",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
    })
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        this.renderCart(JSON.parse(response));
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.disableLoading();
      });
  }

  async getQuantityLimiterMetafield(handle) {
    if (!this.quantityLimitCache) this.quantityLimitCache = new Map();

    if (this.quantityLimitCache.has(handle)) {
      return this.quantityLimitCache.get(handle);
    }

    const response = await fetch(`/products/${handle}?view=quantity-limit`);
    if (!response.ok) {
      this.quantityLimitCache.set(handle, null);
      return null;
    }

    const limit = (await response.text()).trim();
    const parsedLimit = limit ? parseInt(limit, 10) : null;
    this.quantityLimitCache.set(handle, parsedLimit);
    return parsedLimit;
  }

  async getOrderLimit(productDetails, item) {
    const metafieldLimit = await this.getQuantityLimiterMetafield(item.handle);
    if (metafieldLimit) return metafieldLimit;

    if (productDetails.tags.indexOf("limitone") > -1) return 1;
    if (productDetails.tags.indexOf("limittwo") > -1) return 2;

    return null;
  }

  renderCartItem(item, index, cartItemList, productTemplate, productOptionTemplate) {
    fetch(`/products/${item.handle}.js`, {
      method: "GET",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
    })
      .then((response) => {
        return response.text();
      })
      .then(async (details) => {
        const productDetails = JSON.parse(details);

        var cartItemHTML = productTemplate;
        cartItemHTML = cartItemHTML.replace(/{index}/gi, index + 1);
        cartItemHTML = cartItemHTML.replace(/{product_quantity}/gi, item.quantity);
        cartItemHTML = cartItemHTML.replace(/{product_variant_id}/gi, item.variant_id);
        cartItemHTML = cartItemHTML.replace(/{product_id}/gi, item.product_id);
        cartItemHTML = cartItemHTML.replace(/{product_title}/gi, item.product_title);
        cartItemHTML = cartItemHTML.replace(/{product_image_src}/gi, item.image);
        cartItemHTML = cartItemHTML.replace(/{product_price}/gi, formatAsCurrency(item.final_price / 100));

        var cartItemOptionsHTML = "";
        item.options_with_values.forEach((opt) => {
          var optionsHTML = productOptionTemplate;
          optionsHTML = optionsHTML.replace(/{name}/gi, `${opt.name}:`);
          optionsHTML = optionsHTML.replace(/{value}/gi, opt.value);
          cartItemOptionsHTML += optionsHTML;
        });
        cartItemHTML = cartItemHTML.replace(/{product_options}/gi, cartItemOptionsHTML);

        if (productDetails.compare_at_price > productDetails.price) {
          cartItemHTML = cartItemHTML.replace(
            /{final_sale_msg}/gi,
            "<div class='cart-notification-product__option h4 final-sale'><dt>Final Sale</dt></div>"
          );
        } else {
          cartItemHTML = cartItemHTML.replace(/{final_sale_msg}/gi, "");
        }

        if (item.discounts && item.discounts.length > 0) {
          var discountItems = "";
          item.discounts.forEach((discount) => {
            discountItems += `<div class='cart-notification-product__option h4 discount-message'><dt>${discount.title}</dt></div>`;
          });

          cartItemHTML = cartItemHTML.replace(/{discount_msgs}/gi, discountItems);
        } else {
          cartItemHTML = cartItemHTML.replace(/{discount_msgs}/gi, "");
        }

        const orderLimit = await this.getOrderLimit(productDetails, item);

        if (orderLimit) {
          cartItemHTML = cartItemHTML.replace(/{product_limit}/gi, orderLimit);
          cartItemHTML = cartItemHTML.replace(/{product_qty}/gi, orderLimit);
        } else {
          cartItemHTML = cartItemHTML.replace(/{product_limit}/gi, "");
          cartItemHTML = cartItemHTML.replace(/{product_qty}/gi, "");
        }

        cartItemList.innerHTML += cartItemHTML;
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.querySelectorAll('.cart-notification-products button[type="button"].quantity__button').forEach(
          (qtyButton) => qtyButton.addEventListener("click", this.updateQuantity.bind(this))
        );
        this.validateItemQuantity();
      });
  }

  renderCartItems(cartItems, updatedQty) {
    const cartItemList = document.getElementById("cart-notification-products");
    if (cartItems.length > 0) {
      const productTemplate = document.getElementById("product-template").innerHTML;
      const productOptionTemplate = document.getElementById("product-option-template").innerHTML;

      if (updatedQty) {
        const existingItems = cartItemList.querySelectorAll(".cart-notification-product");

        // if the item lists are different sizes something was removed
        if (existingItems.length != cartItems.length) {
          existingItems.forEach((existingItem) => {
            var found = false;
            cartItems.forEach((item) => {
              if (item.variant_id == existingItem.dataset.variant) {
                found = true;
              }
            });
            if (!found) {
              cartItemList.removeChild(existingItem);
            }
          });
        }

        // attempt to find product order limits and show messaging/etc
        this.validateItemQuantity();
      } else {
        cartItemList.innerHTML = "";
        cartItems.forEach((item, index) => {
          this.renderCartItem(item, index, cartItemList, productTemplate, productOptionTemplate);
        });
      }
    } else {
      cartItemList.innerHTML = "<h3 class='cart-notification__cart-empty'>Your cart is empty</h3>";
    }
  }

  setGripUpsellMessage(cartItems) {
    const gripUpsellMsg = document.querySelector(".cart-notification__need-grip");
    var showMsg = false;

    cartItems.forEach((item) => {
      if (item.product_type.toLowerCase() == "decks") {
        showMsg = true;
      }
    });

    if (showMsg) {
      gripUpsellMsg.classList.add("show");
    } else {
      gripUpsellMsg.classList.remove("show");
    }
  }

  renderCart(cartData, updatedQty = false) {
    // build the cart line items
    this.renderCartItems(cartData.items, updatedQty);
    // show grip upsell, if needed
    this.setGripUpsellMessage(cartData.items);

    const adjustedSubtotal = cartData.items_subtotal_price / 100;
    const subTotalLabel = document.querySelector(".cart-price-total");
    const freeShippingMsg = document.querySelector(".cart-notification__free-shipping");

    // show/hide free shipping message
    if (adjustedSubtotal >= 59 && adjustedSubtotal <= 69) {
      freeShippingMsg.classList.add("show");
    } else {
      freeShippingMsg.classList.remove("show");
    }

    // display subtotal
    subTotalLabel.innerHTML = formatAsCurrency(adjustedSubtotal);
  }

  updateQuantity(evt) {
    const target = evt.target;
    const parent = target.parentNode;
    const qtyInput = parent.querySelector("input");

    const line = qtyInput.dataset.index;
    const quantity = qtyInput.value;

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        this.renderCart(JSON.parse(response), true);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  validateItemQuantity() {
    const cartItems = this.querySelectorAll(".cart-notification-products .cart-notification-product");
    cartItems.forEach((item) => {
      const lineQty = item.querySelector(".quantity__input").value;
      const lineLimit = item.dataset.limit;
      const plusButton = item.querySelector('.quantity__button[name="plus"]');
      const limitMessage = item.querySelector(".limit-message");

      // disable plus button and display message?
      if (lineQty == lineLimit) {
        plusButton.classList.add("disabled");
        plusButton.setAttribute("disabled", true);
        limitMessage.innerText = `Purchase Limit ${lineLimit}`;
      } else {
        plusButton.classList.remove("disabled");
        plusButton.removeAttribute("disabled");
        limitMessage.innerText = "";
      }
    });
  }

  enableLoading() {
    const loading = document.getElementById("cart-notification-loading");
    loading.classList.remove("hidden");
  }

  disableLoading() {
    const loading = document.getElementById("cart-notification-loading");
    loading.classList.add("hidden");
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification") && !target.closest("cart-icon")) {
      const disclosure = target.closest("details-disclosure");
      this.activeElement = disclosure ? disclosure.querySelector("summary") : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
